var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureFlowRateStandard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pipe",
    transform: "matrix(1,0,0,1,0,79.6266)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.52479,0,0,1.0909,6.97826,-29.1968)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.6,
    cy: 68.354,
    rx: 7.45,
    ry: 20.954,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.52479,0,0,1.0909,175.041,-29.1922)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6,47.4C34.712,47.4 38.05,56.789 38.05,68.354C38.05,79.919 34.712,89.309 30.6,89.309",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.89px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.97111,0,0,0.967528,-15.1369,-23.3489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.891,47.4L120.154,47.4",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.61px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.97111,0,0,0.967528,-15.1369,-23.3489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.891,94.653L120.154,94.653",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.61px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.739801,0,0,0.967528,10.6893,39.9085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.819,103.845L37.058,103.845L34.057,100.538L38.381,103.845L34.057,107.151L37.058,103.845L29.819,103.845Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.739801,0,0,0.967528,10.6893,28.985)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.819,103.845L37.058,103.845L34.057,100.538L38.381,103.845L34.057,107.151L37.058,103.845L29.819,103.845Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.739801,0,0,0.967528,10.6893,18.0615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.819,103.845L37.058,103.845L34.057,100.538L38.381,103.845L34.057,107.151L37.058,103.845L29.819,103.845Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.739801,0,0,0.967528,10.6893,7.13796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.819,103.845L37.058,103.845L34.057,100.538L38.381,103.845L34.057,107.151L37.058,103.845L29.819,103.845Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.739801,0,0,0.967528,119.325,28.763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.671,103.845L37.058,103.845L34.057,100.538L38.381,103.845L34.057,107.151L37.058,103.845L7.671,103.845Z",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "1.05px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,55.4662,88.1693)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "v")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-27.3971,94.3049)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "A")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-59.904,92.2606)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "Q"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureFlowRateStandard);
export default __webpack_public_path__ + "static/media/calc-figure-flowRate-standard.20b0c4295d6c1ce5121443da0757d58c.svg";
export { ForwardRef as ReactComponent };